import AreaDirectorSortableAdJobsList from '../react/AreaDirectorSortableAdJobsList'
import CopyFieldToClipboard from '../components/CopyFieldToClipboard'
import CreativeDirectorSortableAdJobsList from '../react/CreativeDirectorSortableAdJobsList'
import N2StylesModal from '../components/N2StylesModal'

export default class AdDesignJobs {
  constructor(params) {
    this.params = params;
    this.role = params.role || null
  }

  index() {
    let keys;
    let klass;
    switch(this.role) {
      case "area_director":
        keys = ["my", "cross"]
        klass = AreaDirectorSortableAdJobsList
        return this.sortAds(keys, klass)
        break;
      case "creative_director":
        keys = ["design", "in_design", "design_review", "in_design_review", "proof_out", "building_proof"]
        klass = CreativeDirectorSortableAdJobsList
        return this.sortAds(keys, klass)
        break;
    }
  }

  show() {
    if (this.role == "area_director") {
      this.bindDeadlineAlertListeners();
      this.bindAdInDesignModals();
      this.bindWrongMonthEditBtn();
      this.bindSplitModal();
      new CopyFieldToClipboard();
    } else {
      // CD or ad designer
      this.bindFinishButtons();
      this.bindArchivedAi();
    }

    // if user is ad designer immediately open the VM folder
    if (this.role == "ad_designer"){
      setTimeout(() => {
        $('.js-open-share-folder').click()
      }, 200)
    }
    this.bindPlacementReassignListener()
  }

  bindAdInDesignModals() {
    N2.handle('click', '.js-edit-ad', (e) => {
      if ($(e.target).data('status') == "design") {
        $('.js-ad-return-to-waiting').modal()
      } else {
        $('.js-ad-design-in-progress').modal()
      }
      $('.modal-backdrop').addClass('in')
    })
  }

  bindDeadlineAlertListeners(){
    N2.handle('click', '.js-ad-deadline.disabled', evt => {
      $('.js-ad-deadline-past-modal').modal('show')
      // a side effect I think of two bootstraps
      // TODO remove once BS 3 is gone
      $('.modal-backdrop').addClass('in')
    });

    N2.handle('click', '.js-ad-deadline-reiminder', evt => {
      $('.js-ad-deadline-reiminder-modal').modal('show');
      // a side effect I think of two bootstraps
      // TODO remove once BS 3 is gone
      $('.modal-backdrop').addClass('in')
    });
  }

  bindFinishButtons() {
    N2.handle("click", "#finish-design-button", (e) => {
      let url = $(e.currentTarget).data("url");

      $.getJSON(url, (data) => {
        if (data["error_fields"].length > 0) {

          if (data["error_fields"].includes("proof_size")) {
            new N2StylesModal(".js-invalid-size-modal");

          } else {
            new N2StylesModal(".js-unchanged-proof-modal");

          }
        } else {
          new N2StylesModal(".js-finish-design-modal");
        }
      });
    });
  }

  bindArchivedAi() {
    N2.handle('click', '.js-archived-open-s3-url', (eve) => {
      $.each($(eve.currentTarget).data('urls'), (idx, url) => {
        window.open(url, "_blank")
      });
    })
  }

  bindWrongMonthEditBtn() {
    N2.handle('click', '.js-edit-ad-wrong-month', (e) => {
      e.preventDefault();
      new N2Styles.toast('This job is being worked on in a previous month. Please navigate to the correct month.')
    });
  }

  bindSplitModal() {
    N2.handle('click', '#split-modal', (evt) => {
      $('#js-split-modal').modal('show');
      $('.modal-backdrop').addClass('in');
    });
  }

  sortAds(keys, klass){
    keys.forEach((ele) => {
      if ($(`.js-ads-react-data-${ele}`).length) {
        let list = new klass({
          sortScope: `#sort-filters-${ele}`,
          selector: `.js-ads-list-${ele}`,
          data: $(`.js-ads-react-data-${ele}`).data("jobs"),
          roleType: this.role
        });
        list.render()
      }
    });
  }

  bindPlacementReassignListener() {
    let matchingSelector = "input[type='checkbox'][name='matching_future']";
    N2.bindHandler('change', matchingSelector, function(evt) {
      $('.js-reassign-link').each(function(ele) {
        $("input[type='hidden'][name='ad_placement[matching_future]']", ele).val(evt.target.checked ? '1' : '0')
      })
    });

    let forceSelector = "input[type='checkbox'][name='all_future']";
    N2.bindHandler('change', forceSelector, function(evt) {
      $('.js-reassign-link').each(function(ele) {
        $("input[type='hidden'][name='ad_placement[all_future]']", ele).val(evt.target.checked ? '1' : '0')
      })
    });
  }
}
